module.exports = __webpack_public_path__ + "img/liqpay-white.8e4d61ac.svg";